import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Content from "../Content";
import ContentStep2 from "../ContentStep2";
import ContentStep3 from "../ContentStep3";
import {useLocation} from "react-router-dom";

const steps = ["Stammdaten", "Abo", "Bestätigung"];
const PageContent = ({step}) => {};
export default function HorizontalLinearStepper() {
  const location = useLocation();
  const [activeStep, setActiveStep] = React.useState(
    location.state && location.state.activeStep != null
      ? location.state.activeStep
      : 0
  );
  const [skipped, setSkipped] = React.useState(new Set());
  const [content, setContent] = React.useState("");

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  useEffect(() => {
    // return <Content onClickNext={handleNext} />;
    /* switch (activeStep) {
      case 0:
        return <Content onClickNext={handleNext} />;
      case 1:
        return <ContentStep2 />;
      case 2:
        return <div>Content for Bestätigung</div>;
      default:
        return <div>Unknown step</div>;
    } */
  }, []);

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    const newActiveStep = activeStep + 1;
    setActiveStep(newActiveStep);
    setSkipped(newSkipped);
  };
  // const handleStep2 = (step2) => {
  //   setActiveStep(step2);
  // };
  // const handleStep3 = (step3) => {
  //   setActiveStep(step3);
  // };

  // dynamic function to handleSteps ( jump to any step at any place at any time)

  const handleStep = (value) => {
    setActiveStep(value);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Box sx={{width: "100%"}}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>

      {activeStep === 0 ? (
        <Content onClickNext={handleNext} />
      ) : activeStep === 1 ? (
        <ContentStep2 handleStep={handleStep} />
      ) : (
        <ContentStep3 />
      )}

      {activeStep === steps.length ? (
        <React.Fragment>
          {/* <Box sx={{display: "flex", flexDirection: "row", pt: 2}}>
            <Box sx={{flex: "1 1 auto"}} />
            <Button onClick={handleReset}>Reset</Button>
          </Box> */}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Box>
            <Box sx={{flex: "1 1 auto"}} />
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
}
